module.exports = "https://static.wagwalking.com/_next/static/images/Caregiver-c9de0e8434dd5476c6d202332ca3f906.jpg";